module.exports = __webpack_public_path__ + "static/media/cwp.976d2327.png";